import type { Maybe } from '@adornis/base/utilTypes.js';
import type { NarrowedEntity } from '@adornis/baseql/utils/queryGeneration.js';
import { showDialog } from '@adornis/dialog/dialog-functions.js';
import { stateful } from '@adornis/functional-lit/stateful.js';
import { DialogHeader } from '@adornis/components/client/DialogHeader.js';
import { html } from 'lit';
import type { Person } from '../../users/entities/person.js';

export enum SepaUserChangeDecision {
  CHANGE = 'CHANGE',
  STAY = 'STAY',
}

const SepaChangeUserConfirmDialog = stateful(
  (props: {
    resolve: (decision: SepaUserChangeDecision) => void;
    reject: () => void;
    person: Maybe<NarrowedEntity<Person>>;
  }) => {
    return html`
      <div class="dialog-container">
        ${DialogHeader({
          title: 'Akzeptierende Person wechseln?',
          close: props.reject,
          closeLabel: 'Dialog schließen',
        })}
        <p>
          Möchten Sie die akzeptierende Person auf
          ${
            props.person?.profilDaten?.stammdaten?.vorname && props.person?.profilDaten?.stammdaten?.nachname
              ? `${props.person?.profilDaten?.stammdaten?.vorname} ${props.person?.profilDaten?.stammdaten?.nachname}`
              : props.person?.debitorennummer
          }
          wechseln?
        </p>
        <div class="flex justify-end gap-2 mt-4">
          <button class="btn btn-secondary" @click=${() => props.resolve(SepaUserChangeDecision.STAY)}>
            Beibehalten
          </button>
          <button class="btn btn-primary" @click=${() => props.resolve(SepaUserChangeDecision.CHANGE)}>Wechseln</button>
        </div>
      </div>
    `;
  },
);

export async function openSepaChangeUserConfirmDialog(
  person: Maybe<NarrowedEntity<Person>>,
): Promise<SepaUserChangeDecision> {
  return showDialog({
    content: (resolve, reject) => SepaChangeUserConfirmDialog({ resolve, reject, person }),
    modalBoxClasses: 'max-w-4xl',
  });
}
